import { render } from "./Footer.vue?vue&type=template&id=1c548812"
const script = {}

import exportComponent from "/Users/toyota_macbook/Documents/Projects/mss/vue-seo-friendly-spa-template/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__